function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'citrus': 'rgb(160, 197, 41)','tropical': 'rgb(252, 236, 119)','melon': 'rgb(237, 109, 95)','vert-clair': 'rgb(180, 219, 203)','light-green': 'rgb(180, 219, 203)','gris': 'rgb(192, 192, 192)','blanc': 'rgb(255, 255, 255)','noir': 'rgb(25, 25, 25)','gris-fonce': 'rgb(85, 85, 85)','neutre': 'rgb(25, 25, 25)','neutral': 'rgb(25, 25, 25)','neutral': 'rgb(25, 25, 25)','orange': 'rgb(239, 152, 76)','peche': 'rgb(243, 191, 154)','peach': 'rgb(243, 191, 154)','concombre': 'rgb(62, 156, 107)','cucumber': 'rgb(62, 156, 107)',};

    this.images = {'camo': 'url("//rydrate.com/cdn/shop/files/Camo2_68x.png?v=6358425927011650404")','vert-baie': 'url("//rydrate.com/cdn/shop/files/Vert_Baie_68x.png?v=1678898803604125555")',};

    this.triggers = ['saveurs','saveur ryd-01','saveur ryd-02','saveur ryd-03','saveur ryd-04','couleur','saveur','saveur','flavor','flavor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;

// swatch-color.js.liquid corrigé complet

document.addEventListener('DOMContentLoaded', function () {
  function updateSubscriptionBlocks() {
    document.querySelectorAll('.shopify_subscriptions_app_block_label').forEach(label => {
      const labelText = label.querySelector('label')?.textContent?.trim()?.toUpperCase() || '';
      const benefits = label.querySelector('.subscription-benefits');
      const children = label.querySelector('.shopify_subscriptions_app_block_label_children');
      const isSubscriptionBlock = labelText.includes('ABONNEMENT');

      if (!isSubscriptionBlock) return; // Ne touche pas aux blocs "Achat ponctuel"

      const isSelectedPlan = label.querySelector('input[data-radio-type="selling_plan"]:checked');

      if (isSelectedPlan) {
        label.classList.remove('collapsed');
        if (benefits) benefits.classList.remove('hidden');
        if (children) children.classList.remove('hidden');
      } else {
        label.classList.add('collapsed');
        if (benefits) benefits.classList.add('hidden');
        if (children) children.classList.add('hidden');
      }
    });

    // Relancer les scripts globaux du theme.liquid
    if (typeof window.updateSubscriptionVisibility === 'function') {
      window.updateSubscriptionVisibility();
    }
    if (typeof window.applyRadioDotStyle === 'function') {
      window.applyRadioDotStyle();
    }
  }

  // Initialisation
  updateSubscriptionBlocks();

  // Événements
  document.addEventListener('change', function (e) {
    const target = e.target;
    if (
      target.matches('input[data-radio-type="selling_plan"]') ||
      target.matches('input[data-radio-type="one_time_purchase"]')
    ) {
      setTimeout(updateSubscriptionBlocks, 100);
    }
  });

  const container = document.querySelector('form[action="/cart/add"]');
  if (container) {
    const observer = new MutationObserver(updateSubscriptionBlocks);
    observer.observe(container, { childList: true, subtree: true });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function updateSubscriptionPricing() {
    document.querySelectorAll('.shopify_subscriptions_app_block_label').forEach(block => {
      const priceWrapper = block.querySelector('.shopify_subscriptions_in_widget_price');
      const radio = block.querySelector('input[type="radio"]');
      if (!priceWrapper || !radio) return;

      const price = radio.getAttribute('data-variant-price');
      const compareAt = radio.getAttribute('data-variant-compare-at-price');

      if (!price) return;

      // Évite d'ajouter deux fois
      if (priceWrapper.querySelector('.custom-pricing')) return;

      const priceFormatted = price.replace(' CAD', '').trim();

      if (compareAt && price !== compareAt) {
        const compareFormatted = compareAt.replace(' CAD', '').trim();
        priceWrapper.innerHTML = `
          <div class="custom-pricing" style="display: flex; gap: 8px; align-items: center;">
            <span style="text-decoration: line-through; font-weight: 600; font-size: 13px; color: #000;">${compareFormatted}</span>
            <span style="font-weight: 450; font-size: 13px; color: #000;">${priceFormatted}</span>
          </div>
        `;
      } else {
        priceWrapper.innerHTML = `
          <div class="custom-pricing" style="font-weight: 600; font-size: 13px; color: #000;">${priceFormatted}</div>
        `;
      }
    });
  }

  function observePriceBlocks() {
    document.querySelectorAll('.shopify_subscriptions_app_block_label').forEach(block => {
      const targetNode = block.querySelector('.shopify_subscriptions_in_widget_price');
      if (!targetNode) return;

      const observer = new MutationObserver(() => {
        updateSubscriptionPricing();
      });

      observer.observe(targetNode, { childList: true, subtree: true });
    });
  }

  function cleanupSubscriptionClasses() {
    const blocks = document.querySelectorAll('.shopify_subscriptions_app_block_label');
    blocks.forEach(block => {
      block.classList.remove('abonnement-actif', 'achat-actif');
      const input = block.querySelector('input[type="radio"]');
      if (input?.checked) {
        if (input.dataset.radioType === 'selling_plan') {
          block.classList.add('abonnement-actif');
        } else if (input.dataset.radioType === 'one_time_purchase') {
          block.classList.add('achat-actif');
        }
      }
    });
  }

  // Initialisation au chargement
  updateSubscriptionPricing();
  observePriceBlocks();
  cleanupSubscriptionClasses();

  // Observation globale pour re-appliquer les classes et prix après mutation
  const globalObserver = new MutationObserver(() => {
    updateSubscriptionPricing();
    observePriceBlocks();
    cleanupSubscriptionClasses();
  });
  globalObserver.observe(document.body, { childList: true, subtree: true });

  // Réaction aux changements manuels
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[type="radio"]')) {
      setTimeout(() => {
        cleanupSubscriptionClasses();
        updateSubscriptionPricing();
      }, 50);
    }
  });
});

